import { useEffect, useState } from "react";
import axios from "axios";
import Loader from "../components/Loader";
import "../assets/css/activity.css";
import Title from "../components/Title";
import { useSelector } from "react-redux";
import { FaTimes } from "react-icons/fa";

const Activity = () => {
  const { url, user } = useSelector((state) => state.user);
  const [loading, setLoading] = useState(false);
  const [data1, setData1] = useState([]);
  const [data2, setData2] = useState([]);

  const getActivityToken = async () => {
    try {
      const res = await axios.get(`${url}/activity_token`);
      return res.data.token[0].token;
    } catch (error) {
      console.log(error);
    }
  };

  const getActivity = async () => {
    setLoading(true);
    try {
      const token = await getActivityToken();
      const res = await axios.get(
        `${url}/proxy?url=https://www.zohoapis.in/creator/v2.1/data/settlemyloan/sml/report/All_Activity_Time_Line?Customer_Email=${user.Email}`,
        {
          headers: {
            Authorization: `Zoho-oauthtoken ${token}`,
          },
        },
      );
      if (res.status === 200) {
        setData1(res.data.data);
        setData2(res.data.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getActivity();
  }, []);
  //
  const [replyModal, setReplyModal] = useState(false);
  const [reply, setReply] = useState({
    id: "",
    text: "",
  });
  const openReploModal = (item) => {
    setReplyModal(true);
    setReply({
      ...reply,
      id: item.ID,
    });
  };
  const handleReplyText = (e) => {
    setReply({
      ...reply,
      text: e.target.value,
    });
  };
  const [replyError, setReplyError] = useState("");
  const sendReply = async () => {
    if (!reply.text) {
      setReplyError("Enter your reply");
    } else {
      const data = [
        {
          Customer_Comments: reply.text,
        },
      ];

      const token = await getActivityToken();
      const res = await axios.put(
        `${url}/proxy?url=https://www.zohoapis.in/creator/v2.1/data/settlemyloan/sml/report/All_Activity_Time_Line/${reply.id}`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Zoho-oauthtoken ${token}`,
          },
        },
      );
      if (res.data.code === 3000) {
        closeReplyModal();
        getActivity();
      } else {
        setReplyError("Something went wrong. Please try again later");
      }
    }
  };
  const closeReplyModal = () => {
    setReply({
      id: "",
      text: "",
    });
    setReplyError("");
    setReplyModal(false);
  };

  return (
    <>
      <div className="payments-container">
        <Title title="Activity" />
        <hr />
        <div className="project-table-overflow">
          {loading === true ? (
            <Loader />
          ) : (
            <>
              {data2.length === 0 ? (
                <p className="text-center">No data found</p>
              ) : (
                <table className="project-table activity-table">
                  <thead>
                    <tr>
                      <th>Sr</th>
                      <th>Remarks</th>
                      <th>Comment</th>
                      <th>Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data2.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>
                            <p className="activity-clamp">
                              {item.Remark || "-"}
                            </p>
                          </td>
                          <td>
                            {item.Customer_Comments === "" ? (
                              <button
                                className="button"
                                onClick={() => openReploModal(item)}
                              >
                                Reply
                              </button>
                            ) : (
                              <p className="activity-clamp">
                                {item.Customer_Comments}
                              </p>
                            )}
                          </td>
                          <td>{item.Date_field || "-"}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              )}
            </>
          )}
        </div>
      </div>

      <div className={`modal-background ${replyModal ? "active" : ""}`}>
        <div className="modal-container message-modal-container py-4">
          <div className="d-flex align-items-center justify-content-between gap-2 mb-4">
            <p className="fw-bold">#{reply.id}</p>
            <button className="red-button" onClick={closeReplyModal}>
              <FaTimes />
            </button>
          </div>
          <div>
            <textarea
              className="input"
              value={reply.text}
              onChange={handleReplyText}
            ></textarea>
            <div className="text-end">
              <button className="button" onClick={sendReply}>
                Send
              </button>
            </div>
          </div>
          <p className="text-danger">{replyError}</p>
        </div>
      </div>
    </>
  );
};

export default Activity;
